// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const deoxys_speed: PokeData = {
  "id": 10003,
  "name": "deoxys-speed",
  "height": 17,
  "weight": 608,
  "base_experience": 270,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "wrap",
    "leer",
    "psychic",
    "agility",
    "night-shade",
    "double-team",
    "recover",
    "swift",
    "pursuit",
    "extreme-speed",
    "knock-off",
    "skill-swap",
    "psycho-boost",
    "psycho-shift",
    "zen-headbutt",
    "psyshock"
  ],
  "moves": [
    "leer",
    "psychic",
    "night-shade",
    "pursuit",
    "zen-headbutt",
    "psy-pulse",
    "psychic-fangs",
    "psychic-terrain",
    "psywave",
    "reflect",
    "calm-mind",
    "kinesis",
    "future-sight"
  ],
  "evolution_chain": {
    "id": 202,
    "item": null,
    "species": [
      {
        "name": "deoxys",
        "order": 416,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 81,
    "speed": 209,
    "ability_power": 110
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
